export const SSO_VALID_REGISTER_EMAIL = 'sso_registro_valido_mail';
export const SSO_PWD_VALIDATE_REGISTRY = 'sso_registro_contrasena_validar';
export const SSO_LOGIN_TEXT = 'sso_inicia_sesion_text';
export const NEXT_REGISTRY = 'registro_siguiente';
export const SSO_EMAIL_PLACEHOLDER = 'sso_email_placeholder';
export const EMAIL_REGISTRY = 'registro_mail';
export const SSO_PWD_PLACEHOLDER = 'sso_pwd_placeholder';
export const PWD_REGISTRY = 'registro_contrasena';
export const SSO_SHOW_PWD_PLACEHOLDER = 'sso_show_pwd_placeholder';
export const SSO_HIDE_PWD_PLACEHOLDER = 'sso_hide_pwd_placeholder';
export const EMPTY_PHONE = 'empty_phone';
export const LOGIN_BTN_LABEL = 'login_btn_lbl';
export const PHONE_APA_KEY = 'llave_apa_telefono';
export const VALIDATEPIN_APA_KEY = 'llave_apa_validatePin';
export const RESEND_CODE = 'REENVIAR CODIGO';
